<template>
  <LoadingSkeleton
    :is-loaded="isLoaded"
    height="40px"
  >
    <NorticSelect
      ref="showSelector"
      v-model="innerValue"
      class="show-select"
      is-filterable
      :filter="showFilterFunction"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :list-max-height-nr-of-items="5"
      list-max-height-item-height="58px"
      @change="emitChangeEvent"
    >
      <template #list>
        <NorticSelectItem
          v-for="show in shows"
          :key="show.id"
          :label="show.name"
          :value="show"
        >
          <NorticSelectShowItemContent :show="show" />
        </NorticSelectItem>
      </template>
    </NorticSelect>
  </LoadingSkeleton>
</template>

<script>
import LoadingSkeleton from '@/components/common/misc/loading-skeleton/LoadingSkeleton.vue';
import NorticSelect from '@/components/common/input/nortic-select/NorticSelect.vue';
import NorticSelectItem from '@/components/common/input/nortic-select/nortic-select-item/NorticSelectItem.vue';
import dynamicCustomInput from '@/components/common/input/mixins/dynamicCustomInput';
import NorticSelectShowItemContent
  from '@/components/common/input/event-selector-v3/nortic-select-show-item-content/NorticSelectShowItemContent.vue';

const showFilterFunction = (filterValue, show) => {
  if (!filterValue) {
    return true;
  }

  const lowercaseFilterValue = filterValue.toLocaleLowerCase();
  const conditions = [
    show.name.toLocaleLowerCase().includes(lowercaseFilterValue),
    show.location.name.toLocaleLowerCase().includes(lowercaseFilterValue),
    show.location.city.toLocaleLowerCase().includes(lowercaseFilterValue),
  ];

  return conditions.some((condition) => !!condition);
};

export default {
  name: 'EventSelectorShowSelect',
  components: {
    NorticSelectShowItemContent,
    NorticSelectItem,
    NorticSelect,
    LoadingSkeleton,
  },
  mixins: [dynamicCustomInput({ autoEmit: true })],
  props: {
    isLoaded: {
      type: Boolean,
      default: true,
    },
    shows: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Välj föreställning',
    },
  },
  data() {
    return {
      showFilterFunction,
    };
  },
  methods: {
    locationLabel(location) {
      return `${location?.name || 'Spelplats ej angiven'}, ${location?.city || 'Stad ej angiven'},`;
    },
    startDateLabel(startDate) {
      return `${startDate?.date || 'Datum ej angivet'}, ${startDate?.time || 'Tid ej angivet'},`;
    },
    emitChangeEvent(e) {
      this.$emit('change', e);
    },
  },
};
</script>
